{
  "invite": {
    "title": "Confirm invitation",
    "previewHeading": "You've been invited to join \"{{team}}\"",
    "checking": "Checking invitation…",
    "checkFailed": "Unable to check this invitation.",
    "competitionLabel": "Competition: {{name}}",
    "inviterLabel": "Invited by: {{name}}",
    "inviterLabelUnknown": "Invited by: unknown",
    "teamLabel": "Team: {{name}}",
    "memberCount": "Currently {{count}} / {{max}} members",
    "joinNotice": "Once you join, you'll become a member of this team.",
    "declineForNow": "Not now",
    "checkingSignIn": "Checking your sign-in status…",
    "joining": "Joining team…",
    "accept": "Accept invitation and join",
    "verifyRequired": "Complete the verification challenge before accepting.",
    "signInFirst": "Sign in to accept",
    "createAccountFirst": "Create an account to accept",
    "acceptFailed": "Unable to accept this invitation.",
    "goToDashboard": "Go to My Competitions",
    "expired": {
      "title": "This invitation link has expired",
      "description": "Ask the team captain for a new invitation link."
    },
    "invalidGeneric": {
      "title": "This invitation is no longer valid",
      "description": "Check with the team captain for a new invitation."
    },
    "alreadyInOtherTeam": {
      "title": "You've already joined another team in this competition",
      "description": "You may only join one team per competition.",
      "viewCurrentTeam": "View my current team"
    },
    "alreadyMember": {
      "title": "You're already a member of this team",
      "description": "No need to join again — you can go straight to the competition to see your team's status."
    },
    "teamFull": {
      "title": "This team is currently full",
      "description": "You can contact the team captain about next steps."
    },
    "success": {
      "title": "Joined {{team}}",
      "memberNotice": "You're now a member of this team.",
      "cta": "Enter competition",
      "viewTeam": "View team"
    }
  }
}
